import { render } from "./App.vue?vue&type=template&id=2b95b73d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2b95b73d&lang=css"

import exportComponent from "D:\\vue\\alive-again\\sams-alive-again\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__